import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4AA181",
  d: "M.895 4.264c0-.62.37-1.186.939-1.437L7.36.386c.403-.181.869-.181 1.28 0l5.526 2.44c.568.252.94.817.94 1.438v3.69a9.9 9.9 0 0 1-1.25 4.773c-2.435 4.417-8.488 4.417-11.713 0A9.9 9.9 0 0 1 .895 7.954z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3815_24493)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "#fff",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.184",
    d: "M10.632 6.172 7.014 9.79 5.369 8.146"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }